import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Close")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventStateSpinner = _resolveComponent("EventStateSpinner")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_PageWrapper = _resolveComponent("PageWrapper")!

  return (_openBlock(), _createBlock(_component_PageWrapper, null, {
    "content-center": _withCtx(() => [
      _createVNode(_component_EventStateSpinner, {
        showFailureState: _ctx.hasErrors,
        isLoading: _ctx.isLoading,
        loadingTitle: "Confirming your appointment",
        successTitle: "Your appointment has been confirmed!",
        successMessage: "If you have any question, please contact your clinic directly.",
        failureTitle: "Oops! Something went wrong while trying to confirm your appointment.",
        failureMessage: _ctx.errorMessage
      }, null, 8, ["showFailureState", "isLoading", "failureMessage"]),
      (!_ctx.isLoading && _ctx.showCloseButton)
        ? (_openBlock(), _createBlock(_component_BaseButton, {
            key: 0,
            onClick: _ctx.routeHome
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}